/** Indonesian name for a #rrggbb colour (nearest basic hue), for legends and route details. */
export function colorName(hex: string): string {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex);
  if (!m) return hex;
  const [r, g, b] = [m[1], m[2], m[3]].map((x) => parseInt(x!, 16) / 255) as [number, number, number];
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  if (s < 0.15 || d < 0.08) return l > 0.85 ? 'Putih' : l < 0.15 ? 'Hitam' : 'Abu-abu';
  let h = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  h = (h * 60 + 360) % 360;
  if (h < 15 || h >= 345) return l < 0.35 ? 'Merah tua' : 'Merah';
  if (h < 40) return l < 0.35 ? 'Cokelat' : 'Oranye';
  if (h < 70) return 'Kuning';
  if (h < 165) return 'Hijau';
  if (h < 200) return 'Cyan';
  if (h < 255) return 'Biru';
  if (h < 290) return 'Ungu';
  return 'Pink';
}
